<div class="top-bar">
    <div class="logo-container col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
            <div class="col-xs-9 col-sm-9 col-md-8 col-lg-9 img-row">
                <img class="logo" src="{{logoUrl}}" />
            </div>
            <div class="col-xs-3 col-sm-3 col-md-4 col-lg-3" style="width: 30%;">
                <a class="phone-mobile" href="tel:{{contactNumber}}"></a>
                <a class="phone-desktop pull-right" style="text-align: right;" href="tel:{{contactNumber}}">Get Help:
                    1-{{contactNumber}}</a>
            </div>
        </div>
    </div>
</div>
